"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarrilToast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
function BarrilToast(_a) {
    var { children, css, role = 'alert' } = _a, props = __rest(_a, ["children", "css", "role"]);
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Box, Object.assign({ css: Object.assign({ background: '$success-standard', border: '1px $nonInteractiveAltOutline solid', borderRadius: '$medium', boxShadow: '$downClose', color: '$nonInteractiveAltPredominant', gap: '$2', padding: '$4' }, css), role: role }, props, { children: children })));
}
exports.BarrilToast = BarrilToast;
